/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_2Inputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_2 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make one controlled change, such as increasing a known expense by 10. Verify that the dependent total changes by the same amount. Start with a simple reference before testing a complex formula.`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_2 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`只做一项容易验证的修改，例如将某项支出增加 10，检查相关合计是否同样增加 10。先测试简单引用，再检查复杂公式。`)
};

/**
* | output |
* | --- |
* | "Make one controlled change, such as increasing a known expense by 10. Verify that the dependent total changes by the same amount. Start with a simple referen..." |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_2 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_2(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_2(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_2 as "gc.search_guides.gridcraft_excel_compatibility.sections.1.steps.2" }